const historyEnum = Object.freeze({
  SHIPPING: 7,
  SUCCESS: 8,
  RETURN: 9,
  VOUCHER_TYPE: 1,
  PHYSICAL_TYPE: 2,
});

export default historyEnum;
